<template>
    <div class="cz2__modal-popup cz2__modal-popup--leaving">
        <div class="cz2__modal-popup__body">
            <focus-lock>
                <div class="cz2__modal-popup__content" tabindex="0">
                    <button class="cz2__modal-popup__close" :aria-label="$t('POPUP_CLOSE')" @click.prevent="close">
                    </button>

                    <div class="cz2__modal-popup__header">
                        {{$t('POPUP_LEAVING_HEADER')}}
                    </div>

                    <div class="cz2__modal-popup__body-copy">
                        {{$t('POPUP_LEAVING_BODY')}}
                    </div>

                    <div class="cz2__modal-popup__actions">
                        <button class="cz2__modal-popup__button cz2__modal-popup__button--ok" @click.prevent="confirm">
                            {{$t('POPUP_LEAVING_OK')}}
                        </button>

                        <button class="cz2__modal-popup__button cz2__modal-popup__button--cancel" @click.prevent="cancel">
                            {{$t('POPUP_LEAVING_CANCEL')}}
                        </button>
                    </div>
                </div>
            </focus-lock>
        </div>
    </div>
</template>

<script>
    import FocusLock from 'vue-focus-lock';

    export default {
        components: {
            FocusLock,
        },

        methods: {
            close() {
                this.$store.dispatch('showExitConfirmation', false);
            },

            cancel() {
                this.$store.dispatch('showExitConfirmation', false);
            },

            confirm() {
                this.$store.dispatch('globalCancel');
                this.$store.dispatch('showExitConfirmation', false);
            },
        },
    };
</script>
